export default __webpack_public_path__ + "static/media/question-bank.f49c97e0.svg";